import React from "react";
import styled from "styled-components";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import SearchIcon from "@mui/icons-material/Search";

interface ZoomControlsProps {
    onZoomIn: () => void;
    onZoomOut: () => void;
    zoom: number;
}

const ControlsContainer = styled.div`
    position: absolute;
    bottom: 24px;
    right: 24px;
    display: flex;
    align-items: center;
    background: #FF9A56;
    border-radius: 24px;
    padding: 4px;
    border: 2px solid #1a1a1a;
    box-shadow: 2px 2px 0px rgba(0,0,0,0.5);
    z-index: 20;
`;

const ZoomButton = styled.button`
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: none;
    background: transparent;
    color: #1a1a1a;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;

    &:hover {
        background: rgba(0, 0, 0, 0.1);
    }
`;

const MagnifierIcon = styled.div`
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #1a1a1a;
`;

export const ZoomControls: React.FC<ZoomControlsProps> = ({ onZoomIn, onZoomOut }) => {
    return (
        <ControlsContainer>
            <ZoomButton onClick={onZoomIn} title="Zoom In">
                <AddIcon />
            </ZoomButton>
            <MagnifierIcon>
                <SearchIcon />
            </MagnifierIcon>
            <ZoomButton onClick={onZoomOut} title="Zoom Out">
                <RemoveIcon />
            </ZoomButton>
        </ControlsContainer>
    );
};

export default ZoomControls;
